import { Container } from '@pets-ui/Container/Container'
import { HStack } from '@pets-ui/HStack/HStack'
import { Paper } from '@pets-ui/Paper/Paper'
import { zIndex } from '@pets-ui/tokens/zIndex.stylex'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'

const styles = stylex.create({
  root: {
    padding: 12,
    position: 'fixed',
    zIndex: zIndex.appBar,
    height: 56,
    left: 0,
    right: 0,
    top: 0,
  },
  invisible: {
    visibility: 'hidden',
    height: 56,
  },
})

export interface AppBarProps {
  left?: ReactNode
  right?: ReactNode
  rootStyle?: stylex.StyleXStyles
}

export function AppBar(props: AppBarProps) {
  const { left, right, rootStyle: rootStyleProps } = props

  const renderContent = (rootStyle?: stylex.StyleXStyles) => {
    return (
      <Paper elevation={4} borderRadius={0} rootStyle={[rootStyle, rootStyleProps]}>
        <Container height="100%">
          <HStack height="100%" justifyContent="space-between" alignItems="center" flexWrap="nowrap">
            {left}
            {right}
          </HStack>
        </Container>
      </Paper>
    )
  }

  return (
    <>
      {renderContent(styles.root)}
      <div {...stylex.props(styles.invisible)} />
    </>
  )
}
